/**
 * This is the default index of the Container. It's the 'app' at the root ("/")
 * path. It is expected that we'll redirect this to some other path as we
 * evolve things in the monorepo.
 */

import { useState, type FC } from "react";
import {
  BigCenterMessage,
  coreQueryClient,
  Loading,
  useTimeout,
} from "@granular/fabric3-core";
import { Link } from "react-router-dom";
import ContextSwitcher from "./ContextSwitcher";

const opacity = 0.65;

const Hello: FC<{
  routeIWouldNavigateTo: string;
}> = ({ routeIWouldNavigateTo }) => {
  const { isSuccess, data } = coreQueryClient.user.profile.useQuery();

  const [waitedForLoading, setWaitedForLoading] = useState(false);
  useTimeout(() => setWaitedForLoading(true), 750);
  if (!waitedForLoading) {
    return <Loading />;
  }

  const heading = (
    <>
      Hello<strong>{isSuccess && ` ${data.firstName}`}</strong>!{" "}
      <span role="img" aria-label="waving hello" className="pr-3">
        👋
      </span>
      <br />
      This is our new Fabric3 Container.
    </>
  );

  return (
    <BigCenterMessage color="success" heading={heading}>
      <h2>
        <small
          style={{
            opacity,
          }}
        >
          v{import.meta.env.VITE_FABRIC3_PACKAGE_VERSION} build{" "}
          {import.meta.env.VITE_FABRIC3_SHORTHASH}
        </small>
      </h2>
      <p
        style={{
          opacity,
        }}
      >
        Every app will be lazy-loaded into this one. I don&apos;t do anything.
        I&apos;m just a placeholder for some default root application.
      </p>
      <p>
        In higher environments (i.e. not your laptop), I would redirect to{" "}
        <strong>
          <Link to={routeIWouldNavigateTo}>{routeIWouldNavigateTo}</Link>
        </strong>
      </p>

      <hr />

      <h3>Pick a Context to work on.</h3>
      <ContextSwitcher />
    </BigCenterMessage>
  );
};

export default Hello;
